import axios from "axios";
import { getCookie } from "../../services/cookies.service";

const axiosApiInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

axiosApiInstance.interceptors.request.use(
  async (config) => {
    const value = await getCookie("token");
    if (value) {
      config.headers = {
        Accept: "application/json",
        Authorization: `Bearer ${value}`,
      };
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

export default axiosApiInstance;
